"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isCompleted;

var _getProgress = _interopRequireDefault(require("./getProgress"));

function isCompleted(props) {
  var progress = (0, _getProgress.default)(props);

  if (!progress) {
    return false;
  }

  return progress === 1;
}